import jsPDF from "jspdf"
import "jspdf-autotable"
import { formatNumber } from "../../utilities/Addons"

export const atelierEtat = (ateliers) => {
	const doc = new jsPDF("p", "mm")
	let nbPage = 1
	let head = [
		"#",
		"Etat",
		"Client",
		"Plaques",
		"Marque",
		"Modèle",
		"Total",
		"Depuis le",
	]
	let options = {
		// theme: 'grid',
		styles: {
			font: "times",
		},
		headStyles: {
			valign: "middle",
			halign: "center",
		},
		bodyStyles: {
			valign: "middle",
			halign: "center",
		},
		didDrawPage: () => {
			doc.setFontSize(8)
			doc.setFont(undefined, "normal")
			doc.setFont("times")
			doc.text(nbPage.toString(), 105, 290, "center")
			nbPage++
		},
	}
	let body = []
	let index = 1
	for (let atelier of ateliers) {
		let temp = []
		temp.push(index)
		temp.push(atelier.etat)
		temp.push(atelier.client_label)
		temp.push(atelier.plaques)
		temp.push(atelier.marque)
		temp.push(atelier.modele)
		temp.push(formatNumber(atelier.total || 0))
		temp.push(atelier.date)
		body.push(temp)
		index++
	}
	doc.autoTable(head, body, options)
	doc.save()
}
